export default __webpack_public_path__ + "static/secondImg-3f9021b2f9ba01cf44575961b7ed593c.png";